import * as React from "react";
import { OTPInput, OTPInputContext } from "input-otp";
import { cn } from "../../lib/utils";

const InputOTP = React.forwardRef(({ className, containerClassName, ...props }, ref) => (
  <OTPInput
    ref={ref}
    containerClassName={cn("tw-flex tw-items-center tw-gap-2", containerClassName)}
    style={{ display: "flex", alignItems: "center", gap: 8 }}
    className={cn("disabled:tw-cursor-not-allowed disabled:tw-opacity-50", className)}
    {...props}
  />
));
InputOTP.displayName = "InputOTP";

const InputOTPGroup = React.forwardRef(({ className, style, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("tw-flex tw-items-center", className)}
    style={{ display: "flex", alignItems: "center", gap: 8, ...style }}
    {...props}
  />
));
InputOTPGroup.displayName = "InputOTPGroup";

// Renders one visual OTP box for the digit at `index`. input-otp manages a
// single real (visually hidden) input under the hood and exposes each
// character's state via context — this box is purely presentational, styled
// inline (not via Tailwind classes) since inline styles are what reliably
// render in this codebase.
const InputOTPSlot = React.forwardRef(({ index, className, style, hasError, ...props }, ref) => {
  const inputOTPContext = React.useContext(OTPInputContext);
  const { char, hasFakeCaret, isActive } = inputOTPContext.slots[index];

  return (
    <div
      ref={ref}
      className={cn("tw-relative", className)}
      style={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "clamp(34px, calc(100vw / 10), 46px)",
        height: "clamp(38px, calc(100vw / 10), 46px)",
        borderRadius: 10,
        border: `1px solid ${hasError ? "#f27059" : isActive ? "rgba(0,173,181,0.6)" : "rgba(255,255,255,0.14)"}`,
        background: "rgba(255,255,255,0.03)",
        color: "#fff",
        fontSize: 16,
        fontWeight: 600,
        boxShadow: isActive ? "0 0 0 3px rgba(0,173,181,0.18)" : "none",
        transition: "border-color 0.12s ease, box-shadow 0.12s ease",
        ...style,
      }}
      {...props}
    >
      {char}
      {hasFakeCaret && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "none",
          }}
        >
          <div style={{ width: 1, height: 18, background: "#fff" }} />
        </div>
      )}
    </div>
  );
});
InputOTPSlot.displayName = "InputOTPSlot";

export { InputOTP, InputOTPGroup, InputOTPSlot };
